export default class playerContext {
  #play;
  #pause;
  #setTime;
  #setPlaybackRate;
  #openFiles;
  #requestRefresh;
  #contextStateChangedCallbacks = [];
  #gpsDataChangedCallbacks = [];
  #gpsFileChangedCallbacks = [];
  #newPlaylistCallbacks = [];

  constructor(
    play,
    pause,
    setTime,
    setPlaybackRate,
    openFiles,
    requestRefresh
  ) {
    this.#play = play;
    this.#pause = pause;
    this.#setTime = setTime;
    this.#setPlaybackRate = setPlaybackRate;
    this.#openFiles = openFiles;
    this.#requestRefresh = requestRefresh;

    this.playing = false;
    this.playbackRate = 1.0;
    this.videoInformation = {};
    this.gpsInformation = { current: {}, allData: [] };
    this.videoToGpsFileMapping = [];
    this.playlistIndex = 0;
    this.playingName = "";

    this.requestPlay = this.requestPlay.bind(this);
    this.requestPause = this.requestPause.bind(this);
    this.requestTime = this.requestTime.bind(this);
    this.requestPlaybackRate = this.requestPlaybackRate.bind(this);
    this.requestOpenFiles = this.requestOpenFiles.bind(this);
  }

  get hasData() {
    return this.gpsInformation && this.gpsInformation.allData.length > 0;
  }

  onContextStateChanged(callback) {
    this.#contextStateChangedCallbacks.push(callback);
  }

  notifyStateSubscribers() {
    this.#contextStateChangedCallbacks.forEach((callback) => callback(this));
  }

  onNewPlaylist(callback) {
    this.#newPlaylistCallbacks.push(callback);
  }

  notifyNewPlaylistSubscribers() {
    this.#newPlaylistCallbacks.forEach((callback) => callback(this));
  }

  onGpsDataChanged(callback) {
    this.#gpsDataChangedCallbacks.push(callback);
  }

  removeOnGpsDataChanged(callback) {
    this.#gpsDataChangedCallbacks.forEach((func, i) => {
      if (func === callback) {
        this.#gpsDataChangedCallbacks.splice(i, 1);
      }
    });
  }

  notifyGpsDataSubscribers() {
    this.#gpsDataChangedCallbacks.forEach((callback) =>
      callback(this.gpsInformation.current)
    );
  }

  onGpsFileChanged(callback) {
    this.#gpsFileChangedCallbacks.push(callback);
  }

  notifyGpsFileSubscribers() {
    this.#gpsFileChangedCallbacks.forEach((callback) =>
      callback(this.gpsInformation)
    );
  }

  requestPlay() {
    this.#play && this.#play();
    this.playing = true;
    this.notifyStateSubscribers();
  }

  requestPause() {
    this.#pause && this.#pause();
    this.playing = false;
    this.notifyStateSubscribers();
  }

  requestOpenFiles() {
    this.#openFiles && this.#openFiles();
  }

  requestTime(seconds) {
    this.#setTime && this.#setTime(seconds);
  }

  requestPlaybackRate(rate) {
    if (this.videoToGpsFileMapping.length === 0) return;
    this.playbackRate = rate;
    this.#setPlaybackRate && this.#setPlaybackRate(rate);
    this.notifyStateSubscribers();
  }

  requestRefresh() {
    this.#requestRefresh && this.#requestRefresh();
  }

  setVideoInformation(info) {
    this.videoInformation = {
      ...(this.videoInformation || {}),
      ...info,
    };
    this.notifyStateSubscribers();
  }

  setGpsInformation(info, gpsFileUpdated = false) {
    const oldGpsData = this.gpsInformation.current;
    this.gpsInformation = {
      ...(this.gpsInformation || {}),
      ...info,
    };
    if (oldGpsData !== this.gpsInformation.current) {
      this.notifyGpsDataSubscribers();
    }
    if (gpsFileUpdated) {
      this.notifyGpsFileSubscribers();
    }
  }

  setPlayerFiles(videoToGpsFileMapping, playlistIndex, isNew) {
    this.videoToGpsFileMapping = videoToGpsFileMapping;
    this.playlistIndex = playlistIndex ?? this.playlistIndex;
    this.notifyStateSubscribers();
    if (isNew) this.notifyNewPlaylistSubscribers();
  }

  setPlaylistIndex(index) {
    this.playlistIndex = index;
    this.notifyStateSubscribers();
  }
}
